import { Component, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthorizeService } from '../../services/authorize.service';
import { LoadingMaskComponent } from '../../components/loading-mask/loading-mask.component';
import { NgIf, AsyncPipe } from '@angular/common';
import { StatefulComponent } from '../../components/stateful/stateful.component';
import { setUserDetailAction, setPermissionsAction, setContainerTypeAction } from '../../ngrx/actions/global.actions';
import * as GarageActions from '../../ngrx/actions/garage.actions';
import { authModuleRoutes } from '../../routes/api-authorization-routes';
import { StorageService } from '../../services/storage.service';

// The main responsibility of this component is to handle the user's logout process.
// This is the starting point for the logout process, which is usually initiated when a
// user clicks on the logout button on the LoginMenu component.
@Component({
    selector: 'app-logout',
    templateUrl: './logout.component.html',
    styleUrls: ['./logout.component.scss'],
    standalone: true,
    imports: [NgIf, LoadingMaskComponent, AsyncPipe]
})
export class LogoutComponent extends StatefulComponent implements OnInit {
  public message = new BehaviorSubject<string | null>(null);

  constructor(
    private authorizeService: AuthorizeService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private storageService: StorageService) {
      super();
    }

  async ngOnInit() {
    this.dispatch(setContainerTypeAction({ containerType: 'normal' }));
    const action = this.activatedRoute.snapshot.url[0];
    switch (action.path) {
      case authModuleRoutes.logout:
        await this.logout();
        break;
      case authModuleRoutes.logoutCallback:
        await this.processLogoutCallback();
        break;
      case authModuleRoutes.loggedOut:
        this.router.navigate(['./']);
        break;
      default:
        throw new Error(`Invalid action '${action}'`);
    }
  }

  private async logout(): Promise<void> {
    this.storageService.removeItem("accessToken");
    this.storageService.removeItem("accessTokenExpirey");
    this.storageService.removeItem("refreshToken");
    this.storageService.removeItem("refreshTokenExpirey");
    this.storageService.removeItem("user");
    this.storageService.removeItem("permissions");
    this.authorizeService.setUserSubject(null);
    this.dispatch(setUserDetailAction({ userDetail: undefined }));
    this.dispatch(setPermissionsAction({ permissions: undefined }));
    // Clear garage state to prevent data leakage between user sessions
    this.dispatch(GarageActions.clearVehicles());
    this.router.navigate(['/']);
    return Promise.resolve();
  }

  private async processLogoutCallback(): Promise<void> {
    this.router.navigate(['/']);
    return Promise.resolve();
  }
}
